import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class GetArticlePriceListErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [{
                'code': 'no_article_price_list_available_for_customer',
                'text': 'No article price list available for customer',
            }]
        }
    }

    static errorCodes() {
        return ['no_article_price_list_available_for_customer'];
    }
}